import React from "react";
import "./Help.css";
import { 
  FaRegCalendarAlt, FaIdBadge, FaUserCheck, FaDog, FaChild, FaConciergeBell,
  FaSmokingBan, FaShieldAlt, FaPhoneAlt, FaExclamationTriangle 
} from "react-icons/fa";

const HelpGuestPolicy = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Guest Policies</h2>
          <p className="text-muted">
            Understand the booking, check-in, cancellation, safety, and conduct policies for YOVHO hotels, homes, and stays.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon"><FaRegCalendarAlt /></div>
            <div className="helpText">
              <h5>General Booking Policy</h5>
              <p>
                Guests must comply with local laws and travel guidelines at their destination. All booking-related policies including check-in requirements, cancellations, and house rules are property-specific and clearly communicated during reservation.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon"><FaIdBadge /></div>
            <div className="helpText">
              <h5>Check-In Policy</h5>
              <ul>
                <li>Primary guest must be 18+ years old.</li>
                <li>Standard check-in: 12:00 noon.</li>
                <li>All guests 18+ must present a valid government-issued photo ID (CNIC/Passport). No photocopies or digital IDs accepted.</li>
                <li>Unmarried couples are not permitted; proof of marriage may be requested.</li>
              </ul>
              <p>
                If you face check-in issues, contact Customer Care: +92 316 6611136 or customer.care@yovho.com. Options may include relocation or full refund (limited to original booking value).
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon"><FaUserCheck /></div>
            <div className="helpText">
              <h5>Early/Late Check-In & Check-Out</h5>
              <p>
                Subject to availability. Applicable charges:
              </p>
              <table>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Charges</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>Before 6:00 AM</td><td>100% of room rate (previous day)</td></tr>
                  <tr><td>6:00 AM – 10:00 AM</td><td>0%–30% based on hotel policy</td></tr>
                  <tr><td>10:00 AM – 12:00 PM</td><td>Complimentary</td></tr>
                  <tr><td>Check-out 11:00 AM – 1:00 PM</td><td>Complimentary</td></tr>
                  <tr><td>1:00 PM – 5:00 PM</td><td>Up to 30% of room rate</td></tr>
                  <tr><td>After 5:00 PM</td><td>100% of room rate</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon"><FaDog /></div>
            <div className="helpText">
              <h5>Pet Policy</h5>
              <p>
                Applicable only at select properties. Pets must be vaccinated; vaccination certificate required at check-in. Dogs and cats only, max 1 per room. Pets must be on a leash and are not allowed on beds, pools, or restaurants. Extra cleaning fees may apply.
              </p>
            </div>
          </div>

          {/* 5 */}
          <div className="helpItem">
            <div className="helpIcon"><FaChild /></div>
            <div className="helpText">
              <h5>Child Policy</h5>
              <p>
                One child under 5 may stay free without extra mattress. Breakfast charges may apply for children depending on the property.
              </p>
            </div>
          </div>

          {/* 6 */}
          <div className="helpItem">
            <div className="helpIcon"><FaSmokingBan /></div>
            <div className="helpText">
              <h5>Smoking, Drugs & Alcohol Policy</h5>
              <p>
                Smoking not permitted in YOVHO Townhouse properties. Drug use or possession strictly prohibited. Alcohol not allowed in rooms or public areas.
              </p>
            </div>
          </div>

          {/* 7 */}
          <div className="helpItem">
            <div className="helpIcon"><FaShieldAlt /></div>
            <div className="helpText">
              <h5>Safety & Security</h5>
              <p>
                Follow fire safety and emergency procedures. YOVHO and partners are not responsible for loss or theft of personal belongings. Lock doors and windows when leaving the room.
              </p>
            </div>
          </div>

          {/* 8 */}
          <div className="helpItem">
            <div className="helpIcon"><FaPhoneAlt /></div>
            <div className="helpText">
              <h5>Contact & Support</h5>
              <p>
                Pre-arrival, YOVHO may contact guests to confirm details. Non-response may temporarily hold or cancel your reservation. For help during stay, contact support 24/7 at +92 316 6611136 or support@yovho.com.
              </p>
            </div>
          </div>

          {/* 9 */}
          <div className="helpItem">
            <div className="helpIcon"><FaExclamationTriangle /></div>
            <div className="helpText">
              <h5>Fraud Awareness</h5>
              <p>
                Only use authorized payment channels (YOVHO website/app, verified payment links, trusted OTA gateways). Report any suspicious payment requests to fraud.alert@yovho.com or call +923166611136.
              </p>
            </div>
          </div>

          {/* 10 */}
          <div className="helpItem">
            <div className="helpIcon"><FaConciergeBell /></div>
            <div className="helpText">
              <h5>Grievance Redressal</h5>
              <p>
                For formal complaints or unresolved issues, contact YOVHO Grievance Officer: +971 555 562053 | +92 316 6611136 or email customer.care@yovho.com.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpGuestPolicy;
